export default {
  "custom": {
    linkedReference: 'Linked Reference',
    boot: 'Power On',
    shutDown: 'Power Off',
    notLinked: 'Not Linked',
    maxLinkedTip: 'Maximum 2 {type} links allowed, auto-reverted to Not Linked',

    bar_Power: 'Power Control',
    bar_Video: 'Video Switch',
    bar_Vol: 'Vol.',
    bar_Audio: 'Audio Switch',
    bar_Serial: 'Serial Control',
    bar_Air: 'Air Conditioner',
    bar_Projection: 'Projection Screen',
    bar_Remote: 'Remote Control',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'You must select all three images at the same time',
    notSelected: 'Not Selected',
    choose: 'Choose',
    disable: 'Disable',
    "longPressAndDrag": "Long press and drag to adjust the list order",
    "isrestoreDefault": "Do you want to restore to the default state?",
    "saveAndSync": "Save and Sync",
    "restoreDefault": "Restore Default",
    "limitPNG": "Only PNG images can be uploaded!",
    "limit1M": "The image size cannot exceed 1MB!",
    "selectTheImage": "Select Image",
    "textsuggestions": "Recommended: 48*48 px white PNG icon under 1MB",
    "iconLibrary": "Icon Library",
    "panelNavigationBarCustomization": "Panel Navigation Bar",
    "logoCustomization": "Panel Logo"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Binding failed: This Microsoft tenant (ID: ',
    AuthVerify4004Two: ") is already occupied by the organization [",
    AuthVerify4004Three: "].To rebind, please first unbind it from the original organization or use a different Microsoft tenant.",
    theMicrosoftTenantIsOccupied: 'The Microsoft tenant is occupied',
    Viewtutorial: 'View the binding tutorial',
    checktenantID: 'Please check whether your tenant ID, application ID, and application key are correct.',
    ErrorCode: 'Error code:',
    AuthorizationFailed: 'Authorization failed',
    Accesshasbeengranted: 'Access to the Microsoft Graph API has been granted',
    successfullyauthorizedDescribe: 'The required permissions have been successfully authorized. The conference room data will be automatically synchronized. Please close this page.',
    Close: 'Close',
    resourceID: 'Resource ID',
    dialogTips: 'Tips',
    theAuthorizationIsDeleted: 'Authorization Removed',
    theBindingIsSuccessful: 'Binding Successful',
    theUnbindingIsSuccessful: 'Unbinding Successful',
    unbindingFailed: 'Unbinding Failed',
    theUnbindingHasBeenUnbound: 'Unbinding Canceled',
    continueUnbinding: 'Outlook sync will stop and all upcoming events will be cleared. Continue unbinding?',
    areYouSureAboutUnbinding: 'All upcoming Outlook events will be cleared and sync will stop. This action cannot be undone. Confirm unbinding?',
    UnbindNotSynchronized: 'After binding, new Outlook events for this room will be synced automatically (past events will not be synced)',
    unbinding: 'Unbind',
    bindUnableToSelect: 'Already bound, unable to select',
    permissAThird: 'Please authorize to bind third-party resources',
    resourceMailbox: 'Resource Email:',
    PleasecheckID: 'Authorization Failed! Please check if your Tenant ID, Application ID, and Client Secret are correct.',
    Waitingforauthorization: 'Waiting for authorization...',
    Pleasecompletetheauthorization: 'Microsoft 365 login page opened. Please sign in with an admin account to complete authorization.',
    pleaseEnterTheTenantID: 'Please Enter Tenant ID',
    pleaseEnterTheClientID: 'Please Enter Application ID',
    pleaseEnterTheClientSecret: 'Please Enter Client Secret',
    Authorizationcompleted: 'Authorization Completed',
    Authorizelogin: 'Authorize Microsoft 365 Login',
    ApplicationID: 'Tenant ID',
    ClientID: 'Application ID',
    ClientSecret: 'Client Secret',
    registTipOne: 'Please follow',
    registTipTwo: 'Binding Guide',
    registTipThree: 'Complete Azure app registration and permission settings before filling in the fields below.',
    MicrosoftDescribe: 'By binding Microsoft 365, meetings booked in Outlook/Teams can be automatically synced to the Q-NEX Console and Room Scheduler.',
    Addcalendarservice: 'Calendar Sync Settings',
    Lasttimesynchronization: 'Last Sync Time',
    Allocated: 'Assigned',
    Total: 'Total',
    Conferenceroomresources: 'Meeting Room Resource',
    Bindingtime: 'Binding Time',
    Bindtheplatform: 'Binding Platform',
    Synchronousstate: 'Sync Status',
    Organizationname: 'Organization Name',
    Bindthirdpartycalendar: 'Bind Third-Party Calendar',
    TenantIDTip: 'Unique Identifier in Azure AD',
    ApplicationIDTip: 'Application ID registered in Azure',
    ApplicationSecretTip: 'Client secret generated in Azure for authentication'
  },
  meetingManager: {
    IdleDisplayTextTable: 'Idle Display Text',
    IdleDisplayText: 'Idle Display Text:',
    IdleDisplayTextContent: 'Text shown when room is empty (default: “Vacant”)',

    duplicateMeetingRoomName: 'Duplicate Meeting Room Name',
    duplicateMeetingRoomNameContent: 'A meeting room named "{duplicate_content}" already exists. Please enter a different name.',
    NumberOfRoomPanels: 'Number of Room Panels',
    Thecurrentterminalhasbeenboundtoanotherorganization: "The current terminal has already been bound to another organization.",
    theTerminalNameOrIDIsDuplicated: 'The panel name or id is the same',
    theRoomNameOrIDIsDuplicated: 'The meeting room name or location is duplicated.',
    AddMeetingRoom: 'Add Meeting Room',
    EditMeetingRoom: 'Edit Meeting Room',
    MeetingRoomName: 'Meeting Room Name:',
    Location: 'Location:',
    ReservationApproval: 'Reservation Approval:',
    ApprovalListYes: 'yes',
    ApprovalListNo: 'no',
    Capacity: 'Capacity:',
    RoomStatus: 'Room Status:',
    BindRoomDisplay: 'Bind Room Panel:',
    meeting_btnAdd: 'Add',
    meeting_btnEdit: 'Edit',
    meeting_btnBind: 'Bind Device',
    meeting_btnDel: 'Delete',
    meeting_tableRoomName: 'Meeting Room Name',
    meeting_tableRoomPlace: 'Location',
    meeting_tableAppointmentApproval: 'Reservation Approval',
    meeting_tableCapacityForPeople: 'Capacity',
    meeting_tableMeetingRoomStatus: 'Room Status',
    meeting_tableAvaliable: 'Available',
    meeting_tableOutofService: 'Out of Service',
    meeting_tableDoorBind: 'Door Bind',
    meeting_tableBindNPS: 'Bind NPS',
    meeting_tableActions: 'Actions',
    door_theNameOfTheTerminal: 'Panel Name:',
    door_deviceID: 'Panel ID:',
    door_Wallpaper: 'Wallpaper:',
    door_Wallpaper_text: 'Recommended image: size 1280x800, in PNG format',
    door_bindAMeetingRoom: 'Bind Meeting Room:',
    door_table_name: 'Panel Name',
    door_table_deviceID: 'Panel ID',
    door_table_status: 'Status',
    door_table_ipAddress: 'IP Address',
    door_table_bindAMeetingRoom: 'Bind Meeting Room',
    door_btnAdd: 'Add',
    door_btnBatchAdd: 'Batch Add',
    door_btnEdit: 'Edit',
    door_btnBatchEdit: 'Batch Edit',
  },
  InputSourcesLinkage: {
    configurationAddTitle: 'Configuration Add',
    configurationEditTitle: 'Configuration Edit',
    dialogConfigName: 'Config Name',
    selectNMPAndNDP: 'Target Devices',
    powerControl: 'Power Control',
    executeCommand: 'Do',
    tableConfigName: 'Configuration Name',
    selectConfig: 'Please select configuration',
  },
  NPS: {
    Relay: 'Relay',
    RelaySettings: 'Relay Settings',
    DevicePower: 'Device Power control',
    DeviceElevation: 'Elevation Control',
    LinageWithNPSPower: 'linkage with NPS Power',
    PresentationSwitch: 'Presentation Switch',
    Duplicate: 'Duplicate',
    LinkagewithNPSPowe: 'Linkage with NPS Powe',
  },
  PTZ: {
    powerSupplyON: 'Power On',
    powerSupplyOFF: 'Power Off',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    UP: 'UP',
    DOWN: 'DOWN',
    HOME: 'HOME',
    ENLARGE: 'ENLARGE',
    REDUCTION: 'REDUCTION',
    StopMovement: 'Stop Movement',
    STOP: 'Stop Zoom',
    FOCUS: 'FOCUS',
    SET_PRESETS0: 'SET_PRESETS0',
    SET_PRESETS1: 'SET_PRESETS1',
    SET_PRESETS2: 'SET_PRESETS2',
    SET_PRESETS3: 'SET_PRESETS3',
    SET_PRESETS4: 'SET_PRESETS4',
    SET_PRESETS5: 'SET_PRESETS5',
    SET_PRESETS6: 'SET_PRESETS6',
    SET_PRESETS7: 'SET_PRESETS7',
    SET_PRESETS8: 'SET_PRESETS8',
    SET_PRESETS9: 'SET_PRESETS9',

    USE_PRESETS0: 'USE_PRESETS0',
    USE_PRESETS1: 'USE_PRESETS1',
    USE_PRESETS2: 'USE_PRESETS2',
    USE_PRESETS3: 'USE_PRESETS3',
    USE_PRESETS4: 'USE_PRESETS4',
    USE_PRESETS5: 'USE_PRESETS5',
    USE_PRESETS6: 'USE_PRESETS6',
    USE_PRESETS7: 'USE_PRESETS7',
    USE_PRESETS8: 'USE_PRESETS8',
    USE_PRESETS9: 'USE_PRESETS9',
  },
  schedule: {
    startLinkPowerStart: 'Power On (CBXs’ Relay)',
    startLinkPowerStop: 'Power Off (CBXs’ Relay)',
    dehumidification: 'Dry',
    airSupply: 'Fan',
    masterControl: 'main:',
    powerSupply: 'Power',
    lockScreen: 'Lock',
    RecordingControl: 'Recording Control',
    RecordingControlSystem: 'Lecture Capture System',
    LiquidCrystal: 'Interactive Flat Panel',
    projector: 'Projector',
    othertype: 'Other',
    childLock: 'Child lock',
    energySaving: 'Energy saving',
    signalSourceSwitching: 'Input source',
    other: 'Other features:',
    otherFunction: 'Function',
    send: 'Send',
    ON: 'ON',
    OFF: 'OFF',
    btnAddSchedule: 'Restore',
    EditSchedulelist: 'Edit Scheduler',
    AddSchedulelist: 'Add Scheduler',
    RestoreSchedulelist: 'Restore',
    btn: 'Cancel',
    btnNewList: 'New Scheduler',
    ListName: 'Name',
    Cannotquit: 'Mandatory',
    NOCannotquit: 'NO',
    ListValidityPeriod: 'Validity Period',
    ListDescription: 'Description',
    currentSchedule: 'Scheduler list',
    historySchedule: 'History list',
    selectTime: 'Time',
    taskType: 'Task Type',
    selectBroadcasting: 'Broadcasting',
    selectDeviveControl: 'Device Control',
    newSchedule: 'New Task',
    newChecklist: 'New Checklist',
    titleStatus: 'Status',
    titleType: 'Type',
    titleStartTime: 'Start Time',
    titleEndTime: 'End Time',
    titleRepeat: 'Repeat',
    titleName: 'Name',
    titleAction: 'Action',
    tableEnabled: 'Enabled',
    tablePaused: 'Paused',
    tableEdit: 'Edit',
    tableDelete: 'Delete',
    tableVolumeEdit: 'Broadcast Volume',
    tableBroadcastTitle: 'Title',
    tableBroadcastContent: 'Content',
    tableBroadcastList: 'List',
    tableBroadcast: 'Compulsive',
    btnRemoveCompletely: 'Remove Completely',
    btnEnabled: 'Enabled',
    btnPaused: 'Paused',
    btnDelete: 'Delete',
    repeat0: 'MON',
    repeat1: 'TUE',
    repeat2: 'WED',
    repeat3: 'THU',
    repeat4: 'FRI',
    repeat5: 'SAT',
    repeat6: 'SUN',
    dialogTitleAdd: 'New Device Control Task',
    dialogTitleEdit: 'Edit Device Control Task',
    newBroadcastingSchedule: 'New Broadcasting Task',
    editBroadcastingSchedule: 'Edit Broadcasting Task',
    chooseDevice: 'Choose Device',
    timeSetting: 'Time Setting',
    controlBroadcasting: 'Broadcasting Option',
    controlOption: 'Control Option',
    scheduleName: 'Task Name:',
    destination: 'Destination',
    timeTilte: 'Time',
    repeatTitle: 'Repeat',
    dialogRepeat0: 'MON',
    dialogRepeat1: 'TUE',
    dialogRepeat2: 'WED',
    dialogRepeat3: 'THU',
    dialogRepeat4: 'FRI',
    dialogRepeat5: 'SAT',
    dialogRepeat6: 'SUN',
    dialogOnceType: 'Once',
    dialogRepeatType: 'Repeat',
    mainPower: 'Main Power',
    powerControl: 'Power Control',
    tableDisplayInputSwitch: 'Display Input Switch',
    tableAirConditioning: 'Air Conditioner',
    tableProjectionScreen: 'Projection Screen',
    tableElectronicLock: 'Electric Lock',
    interactiveFlatPanel: 'Interactive Flat Panel',
    displayInputSwitch: 'Display Input Switch',
    speakerVolume: 'Speaker Volume',
    MICVolume: 'MIC Volume',
    ProjectionScreen: 'Projection Screen',
    ElectronicLock: 'Electric Lock',
    AirConditioning: 'Air Conditioner',
    AirConditioningPower: 'Power',
    AirConditioningModel: 'Model',
    AirConditioningTEMP: 'TEMP',
    AirConditioningFanSpeed: 'Fan Speed',
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    UP: 'UP',
    DOWN: 'DOWN',
    PowerOFF: 'OFF',
    PowerON: 'ON',
    ModelAuto: 'Auto',
    ModelCool: 'Cool',
    ModelHeat: 'Heat',
    ModelAir: 'Air-side',
    TEMPLow: 'Low',
    TEMPMiddle: 'Middle',
    TEMPHigh: 'High',
    btnSave: 'Save',
    btnNext: 'NEXT',
    StartTime: 'Start Time',
    StopTime: 'Stop Time',
    Mandatory: 'Mandatory',
    Video: 'Video&Audio',
    Notification: 'Notification',
    btnFile: 'Select A Media File',
    LastingTime: 'Lasting Time',
    textTitle: 'Title',
    textContent: 'Content',
    textTitleLetters: 'Less than 60 Letters',
    textContentLetters: 'Less than 320 Letters',
    CannotquitYES: 'YES',
    CannotquitNo: 'No',
    YES: 'YES',
    No: 'No',
    delTitleContent: 'Are you sure you want to delete this scheduler?',
    delTitleListContent: 'The deleted scheduler will be moved to the history list and can be restored',
    deleListTitle: 'Delete scheduler?',
    delTitleListContent1: 'Deleting the scheduler will cause the tasks associated with it to be cleared, please confirm.',
    deleListTitle1: 'Are you sure you want to delete this scheduler?',
    delTitle: 'Delete?',
    btnConfirm: 'Confirm',
    coxAll: 'ALL',
    coxBroadcasting: 'Broadcasting',
    coxDeviveControl: 'Device Control',
    rdMandatory: 'YES',
    noRdMandatory: 'NO',
    startDate: 'Start Date',
    endedDate: 'Ended Date',
    // or:'To',
    or: '-',
    broadcastingType: 'Type',
    ChooseTime: 'Choose Time',
    ChooseDate: 'Choose Date',
    newScheduleList: 'New Scheduler',
    editScheduleList: 'Edit Scheduler',
    listName: 'Name',
    listValidityPeriod: 'Validity Period',
    listDescription: 'Description',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    restoreSuccess: 'Schedule list restored successfully',
    restoreError: 'Schedule list recovery failed',
    restoreTitleContent: 'This time conflicts with the schedule time in the list, please select again',
    Enabled: 'Enabled',
    Paused: 'Paused',
    Title: 'Title:',
    Content: 'Content:',
    errorScheduleNameRequired: 'Task name must be filled',
    errorDeviceRequired: 'Please select the target device',
    deleTitle: 'Are you sure you want to delete this task?',
    loopList: 'Loop List',
    errorPleaseDateRange: 'Please select a date range',
    'addError_2009': 'Duplicate scheduler name',
    conflicts: 'The task time conflicts with the followings:',
    Pleaseagain: 'Please enter again',
    errorScheduleName: 'Task Name',
    errorListName: 'Scheduler Name',
    'today': 'Today',
    'yesterday': 'Yesterday',
    'thisWeek': 'This week',
    'lastWeek': 'Last week',
    'lastMonth': 'Last month',
    'thisMonth': 'This month',
    'times': 'Times',
    TimeConflicts: 'Time Conflicts',
    'editError_2006': 'Device doesn’t found',
    'editError_2010': ' Duplicate task name',
    ListTimeExpired: 'Scheduler time has expired, please select again',
    TimeExpired: 'Time Expired',
    ControlOption: 'Control option is missing',
    Pleaseleastone: 'Please select at least one control option',
    Enter: 'Enter',
    TitleFilled: 'Title must be filled',
    ContentFilled: 'Content must be filled',
    PleaseMediaFile: 'Please select a media file',
    PleaseSchedule: 'Please select a task',
    delTitleScheduleContent: 'The deleted task cannot be recovered.',
    deleTitleSchedule: 'Are you sure to delete this task?',
    deleteScheduleTitle: 'Please select the task to delete',
    PleaseFillColumn: 'Please fill in the name of scheduler',
    PleaseDate: 'Please select the date',
    Previous: 'Previous',
    RemoteControl: 'Remote Control',
    taskhasexpired: 'This task has expired, please contact the creator to update the time.',
    execute: 'Execute',
    // destination:'Destination',
    broadcastingList: 'Broadcasting List',
    volumeSuccess: 'Volume set successfully',
    volumeFailed: 'Volume set failed',
  },
  Automation: {
    nameDuplicate: 'Automatic task name duplicate',
    Automation: 'Automation',
    if: 'If:',
    ifContent: 'The \'IF\' section allows you to set conditions based on sensor data. Choose the sensor and specify conditions such as \'Temperature > 26°C\'.',
    then: 'THEN:',
    thenContent: 'The \'THEN\' section lets you choose devices and define actions for them. Select devices like NMP1, NMP2 and specify actions like \'Turn on + Cool\' for air conditioners.',
    btnDelete: 'Delete',
    Add: 'Add',
    taskName: 'Task Name',
    dialogTaskName: 'Task Name:',
    Statue: 'Status',
    DevicesApplied: 'Devices Applied',
    Operation: 'Operation',
    AirConditioningPower: 'Power',
    AirConditioningModel: 'Model',
    AirConditioningTEMP: 'TEMP',
    AirConditioningFanSpeed: 'Fan Speed',
    bold: 'Swing',
    selectTask: 'Please select task',
    autoTaskAdd: 'Add Automation Task',
    autoTaskEdit: 'Edit Automation Task',
    Destination: 'Destination',
    selectConditions: 'Please specify the action you want to perform.',
    selectDestination: 'Please select the target NMP(s) device(s),then specify the action you want to perform',
    AirConditioningTEMP: 'Temperature',
    AirConditioningHumidness: 'Humidity',
    noData: 'No tasks added yet. Click "Add" button to add tasks.',
  },
  rs232Translation: {
    reliveBinding: 'Unbind',
    RELIVEBINDING: 'Unbind',
    ACTO: 'ACTO',
    AMENA: 'AMENA',
    APPOTRONICS: 'APPOTRONICS',
    APTI: 'APTI',
    ASEE: 'ASEE',
    ASK: 'ASK',
    AUCMA: 'AUCMA',
    AUX: 'AUX',
    BARCO: 'BARCO',
    BENQ: 'BENQ',
    BOERKA: 'BOERKA',
    BOXLIGHT: 'BOXLIGHT',
    Canon: 'Canon',
    CARRIER: 'CARRIER',
    CHANGHONG: 'CHANGHONG',
    CHIGO: 'CHIGO',
    CHRISTIE: 'CHRISTIE',
    Chunlan: 'Chunlan',
    COSTAR: 'COSTAR',
    CROWN: 'CROWN',
    CX: 'CX',
    DAEWOO: 'DAEWOO',
    DAIKIN: 'DAIKIN',
    DIGITEL: 'DIGITEL',
    DONGBAO: 'DONGBAO',
    EIKI: 'EIKI',
    electra: 'electra',
    Electrolux: 'Electrolux',
    EPSON: 'EPSON',
    FEILU: 'FEILU',
    FOUNDER: 'FOUNDER',
    Frestec: 'Frestec',
    Fujitsu: 'Fujitsu',
    Galanz: 'Galanz',
    GREE: 'GREE',
    Haier: 'Haier',
    Hisense: 'Hisense',
    HITACHI: 'HITACHI',
    HP: 'HP',
    HUIFENG: 'HUIFENG',
    InFocus: 'InFocus',
    IQ: 'IQ',
    JVC: 'JVC',
    KODAK: 'KODAK',
    LANGER: 'LANGER',
    LENOVO: 'LENOVO',
    LG: 'LG',
    LITTLESWAN: 'LITTLESWAN',
    LUMENS: 'LUMENS',
    McQuay: 'McQuay',
    Microtek: 'Microtek',
    Mitsubishi: 'Mitsubishi',
    NANFENG: 'NANFENG',
    NEC: 'NEC',
    OPTOMA: 'OPTOMA',
    PALOROID: 'PALOROID',
    panisonic: 'panisonic',
    PHILIP: 'PHILIP',
    PJD: 'PJD',
    PLUS: 'PLUS',
    POLAROID: 'POLAROID',
    PROPIX: 'PROPIX',
    PROXIMA: 'PROXIMA',
    RAYBO: 'RAYBO',
    ROWA: 'ROWA',
    Samsung: 'Samsung',
    SANYO: 'SANYO',
    SAST: 'SAST',
    SEEMILE: 'SEEMILE',
    SHARP: 'SHARP',
    shengfeng: 'shengfeng',
    Shinco: 'Shinco',
    shuanglu: 'shuanglu',
    Sony: 'Sony',
    SOVA: 'SOVA',
  },
  VcbEdit: {
    VcbNameNoNull: 'CBX name cannot be empty',
    BrandNoNull: 'Brand cannot be empty',
    ModelNoNull: 'Model cannot be empty',
    AcNoNull: 'A/C Control cannot be empty',
    RcNoNull: 'Remote Control cannot be empty',
  },
  route: {
    customize: 'Customize',
    InputSourcesLinkage: 'InputSourcesLinkage ',
    Automation: 'Automation',
    dashboard: 'Dashboard',
    i18n: 'I18n',
    organizationMge: 'Groups',
    userMge: 'Users',
    authorityMge: 'Permission',
    roleMge: 'Roles',
    equipmentMge: 'Devices',
    workstationMge: 'Media Server',
    cloudDiskMge: 'Storage Control',
    operationLog: 'Operation Log',
    setting: 'Setting',
    resourceMge: 'Resource management',
    storageMge: 'Storage management',
    interfaceRename: 'Interface Rename',
    processorManager: 'Processor Manager',
    projectorCode: 'Serial Code Management',
    projectorCodeSetting: 'Serial Code Settings',
    RepairLog: 'Repair Log',
    remoteControl: 'Remote Control Code',
    acCode: 'A/C Control Code',
    cardMge: 'Cards',
    cardLog: 'Card Usage Log',
    cardManager: 'Card Manager',
    meetingManager: 'Meeting',
    meetingRoomManager: 'Room Management',
    meetingDoorManager: 'Panel Management'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    screenfull: 'Fullscreen',
    language: 'Language',
    userConsole: 'Q-NEX Console',
    BackTianwa: 'Back to Tianwa',
  },
  feedback: {
    Feedback: 'Feedback',
    email: 'Please leave your email for our feedback.',
    content: 'Welcome and leave messages for improving our products. Thanks for your comments.',
    submit: 'Submit',
    emailNoEmpty: 'E-mail can not be empty',
    emailTrueRule: 'Please enter the correct email format',
    contentNoEmpty: 'The content can not be blank',
    feedbackSuccess: 'Feedback success',
    feedbackFailed: 'Feedback failed',
    emailNoChinese: 'Mailbox cannot have Chinese characters',
    emailLength: 'Between 5 and 100 characters in length',
    GroupNameLength: 'Between 1 and 20 characters in length',
    emailSpecialString: 'This input box cannot contain special strings'
  },
  login: {
    title: 'WELCOME',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    placeholder: ["User Name", "Password", "Vercode"],
    userNameTitle: 'Wrong username!',
    forget: 'Forgot it?',
    loginTitle0: 'Log in successfully!',
    loginTitle1000: 'Wrong user name or password!',
    loginTitle1001: 'Username and password must be filled!',
    loginTitle1002: 'Verification code must be filled!',
    loginTitle1003: 'User status is illegal, login failed!',
    loginTitle1004: ' Verification code error!',
    loginTitle1005: 'Not logged in, please login first!',
    loginTitleUserName: 'Username must be filled!',
    loginTitlePwd: 'Password must be filled!',
    loginTitleVercode: 'Verification code must be filled!',
    errorLogin: 'Insufficient user rights, cannot log in!',
    titleLoginNameFormat: 'It must consist of characters, or characters and numbers.'
  },

  organizationMge: {
    CanTDragTop: 'Cannot move to the root',

    prefixCannotBeEmpty: 'The prefix of the super administrator account cannot be empty',
    enterEnglishLetters: 'The super administrator account prefix can only enter English letters and numbers',
    dateNotSelected: 'The start date of the streaming service validity period is not selected',


    btnAddChild: 'Add Subordinate',
    btnAddSibling: 'Add Sibling',
    title: 'Tip:',
    againTitle: 'Please confirm again:',
    sort: 'Sort:',
    realName: 'Real Name:',
    dialogName: 'Name:',
    titleShooleRq: 'This field must be filled',
    titleShooleNub: 'less than 100 letters',
    schoolName: 'Group Name:',
    type: 'Group type:',
    accountPrefix: 'Administrator Account:',
    organization: 'Distributor',
    terminalMechanism: 'End User',
    equipmentNum: 'Device number:',
    organizationNum: 'Terminal groups number:',
    adminName: 'Administrator Account:',
    adminPwd: 'Administrator Password:',
    edit: 'Edit',
    add: 'Add',
    del: 'Delete',
    addSuccess: 'Add successfully',
    addError: 'Add Failed!',
    editSuccess: 'Successfully modified',
    editError: 'Fail to modified!',
    delSuccess: 'Delete successful!',
    delWarn: 'Can not delete this group with bound devices',
    delError: 'Delete Failed!',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    Trial: 'Trial',
    TrialWorkstation: 'You are currently in the trial state that only can push broadcasting and live streaming to 3 terminal devices at most.',
    Normal: 'Normal',
    NormalWorkstation: 'The valid period of your streaming service is from ',
    to: 'to',
    Advent: 'Advent',
    AdventWorkstationOne: 'Your streaming service will expire on  ',
    AdventWorkstationTwo: ', please contact your agent to renew in time for normal use.',
    Expired: 'Expired',
    ExpiredWorkstation: 'Your streaming service has expired, please contact your agent to renew in time. ',
    admin: 'Administrator:',
    serviceState: 'Streaming media service:',
    serviceStateLIST: 'Streaming media service',
    ValidityPeriod: 'Validity Period:',
    ValidityPeriodLIST: 'Validity Period',
    Trial: 'Trial',
    Permanent: 'Permanent',
    AnnualBilling: 'Annual Billing',
    mediaValidityPeriod: 'Validity Period:',
    mediaValidityPeriodLIST: 'Validity Period',
    contactInformation: 'Contact details (For streaming media service renewal prompt)',
    company: 'Company Name:',
    email: 'Email:',
    phone: 'Phone:',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    To: 'To',
    TerminalName: 'End User Name',
    Competence: 'Administrator',
    operate: 'Operate',
    statusFilter: 'StatusFilter',
    disableStreaming: 'Are you sure you want to disable streaming service?',
    enableStreaming: 'Are you sure you want to enable streaming service?',
    disableStreamingContent: 'When streaming service is disabled, the group will not be able to use the related functions of broadcasting and live broadcasting.',
    enableStreamingContent: 'Please modify the validity period for groups with expired streaming service.',
    search: 'Enter organization name',
    optionsYearZero: 'Please choose',
    optionsYearOne: 'One year',
    optionsYearTwo: 'Two years',
    optionsYearThree: 'Three years',

    dialogName: 'Name:',
    detTitle: 'Deleting the group will cause all of the content under it to be deleted together.',
    groupDelTitle: 'Are you sure you want to Delete this group？',
    delTitle: 'Delete?',
    delTitleContent: 'The selected contents will be deleted from database. This operation cannot be undone. Are you sure you want to continue?',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    copySuccess: 'Content has been copied to the clipboard.',
    copyError: 'The browser does not support automatic copy',
    error1200: 'Duplicate group name',
    error1201: 'Group or group ID duplication',
    error1202: 'Exceeded the maximum number of connectable devices',
    error1203: 'Duplicate username',
    error1204: 'There is a group with the same name at the same level',
    error1210: 'Please enter the administrator password',
    warningGroup: 'Choose a group!',
    warningTerminal: 'Terminal group can not create sub-groups!',
    account: 'Duplicate account',
    titleOrganization: 'Note: The account prefix is defined at the organization level. All user accounts under this organization will share the same prefix.',
    all: 'All',
    // titleShooleFormat:' It must consist of characters, or characters and numbers.',

  },
  userMge: {
    nickName: 'Nickname',
    contentWithBrand: 'Enter the brand or model',
    contentwithIp: 'Search by device name or IP address.',
    btnAdd: 'New User',
    btnDelete: 'Delete',
    btnDownload: 'Download Template',
    btnImport: 'Bulk Import',
    btnExport: 'Download',
    btnDisable: 'Disable',
    btnEnable: 'Enable',
    accountType: 'Filter by Role',
    organizationName: 'Filter by Group',
    content: 'Search',
    // manualImport:'手动录入',
    // batchImport: '批量录入',
    // export:'导出',
    // templateDownload:'模板下载',
    // btnEdit:'修改',
    // resetPwd:'重置密码',
    // restart:'启用',
    // disable:'停用',
    // obsolete:'作废',
    systemAccount: 'User ID',
    idCardNumber: 'Employee ID',
    customizeAccount: 'Customize Account',
    userName: 'Name',
    licenseNum: 'license number',
    phone: 'Phone',
    email: 'Email',
    // sex:'Sex',
    role: 'Role',
    status: 'Status',
    // associate:'关联的组织机构',
    affiliatedOrganization: 'Groups',
    // search:'搜索',
    roleTypeList1: "General User",
    roleTypeList2: "Student",
    roleTypeList3: "Parent",
    roleTypeList101: "Agent Admin",
    roleTypeList102: "Administrator",
    roleTypeList301: "Super Admin",
    userStatus1: "Active",
    userStatus2: "Block",
    userStatus3: "Delete",
    // roleTypeList:{1:"老师",2:"学生",3:"家长",101:"机构管理员",102:"终端机构管理",301:"超级管理员"},
    operate: 'Actions',
    dialogName: "Nickname:",
    dialogUserName: "User ID:",
    dialogUserNameDefined: "User Name:",
    dialogPassword: "Password:",
    dialogID: "Employee ID:",
    dialogRole: "Role:",
    dialogEmail: "Email:",
    dialogPhone: "Phone:",
    dialogGroup: "Group:",
    // edit:'Edit',
    // add:'Add',
    addUser: 'New User',
    editUser: 'Edit User',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    tableDel: 'Delete',
    tableEdit: 'Edit',
    selectRoles: 'Select Roles',
    delTitle: 'Delete?',
    delTitleContent: 'The selected contents will be deleted from database. This operation cannot be undone. Are you sure you want to continue?',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    titleRealNameRq: 'This field must be filled',
    titleRealNameFormat: 'Choose a username that contains only letters and numbers.',
    checkPasswordTitleTwo: 'Please set a password of at least 6 characters, including letters and numbers. Special characters are allowed (no restrictions).',
    checkPasswordTitle: 'Password must be at least 6 characters and cannot be all numbers',
    titlePhoneFormat: 'Phone can only fill in numbers, () + and -.',
    phoneFilled: 'Phone must be filled.',
    titleEmaileFormat: 'Email format error.',
    emaileFilled: 'Email must be filled.',
    titlUserNameDefinedNub: 'Username cannot exceed 30 characters',
    titlRealNameNub: 'Name cannot exceed 30 characters.',
    titlRealNameField: 'Name must be filled.',
    thisPasswordField: 'Password must be filled.',
    titlPassWordNub: 'Password must be between 6~30 characters',
    // selectRecord:'Please select activation code record!',
    enableStatus: 'Enable User',
    stopStatus: 'Disable User',
    enableContent: 'Are you sure to enable the user(s)?',
    stopContent: 'Are you sure you want to disable the user(s)?',
    error1400: 'Username already exists, please try again',
    error1401: 'User ID already exists and the operation failed!',
    error1402: 'The group does not exist, the import failed!',
    error1403: 'Data is wrong',
    error1404: 'Insufficient permissions',
    selUser: 'Please select a user!',
    error1405: 'Failed to get role',
    error1406: 'The data format of imported user information is incorrect',
    error1407: 'The email already exists and the operation failed.',
    error1408: 'The phone already exists and the operation failed.',
    error1900: 'The parameter accessed is empty',
    error1610: 'Please use the terminal administrator role to perform related operations',
    errorOrgIdList: 'Group cannot be empty!',
    Bindsucceeded: "Bind succeeded",
    Bindfailed: 'Bind failed',
    tableuserName: 'User Name',
    titleDevice: 'Device',
    bindDevice: 'Binding Device',
    Bindcontrollable: 'Bind controllable device now?',

  },
  devicesMge: {
    mustChooseOne: 'When smart remote control is selected, at least one control command must be chosen',
    customName: 'Custom Name',
    testAcCode: 'Test New A/C control code',
    Online: 'Online',
    Offline: 'Offline',
    unBindConfirm: 'Confirm to unbind Serial',
    unBindConfirm485: 'Confirm to unbind RS485',
    notYetBoundRS232: 'The device is not yet bound to an Serial code. You can go to Device > Serial Control Code to add it.',
    RsFollowingFunctions: 'can achieve the following functions through Serial codes:',
    Unbind: 'Unbind',
    Limit255: 'The file name contains a maximum of 255 characters',
    clear: 'Clear',
    equipName: 'Device Name',
    equipType: 'Type',
    selectField: 'Please select file',
    dialogTip: '*If the input box on the right is empty, the content on the left is displayed by default',
    dialogTipSingle: '*If a single device is not named, follow the name of "ALL"',
    cantDelTemplateOne: 'The CBX of ',
    cantDelTemplateTwo: 'The CBX under device "{deviceName}" is a template. Are you sure you want to delete it?',
    templateTitle: 'Template Replacement',
    templateContentOne: 'The device name "',
    templateContentTwo: '" has been set as the common CBX template. Are you sure to set the current device as the template?',
    vcbNoTemplateNoSave: 'Unable to save without template',
    vcbAcControl: 'Select a A/C Device',
    vcbRemoteControl: 'Select a Remote Control Device',
    vcbPOWERControl: 'Power Control',
    vcbRS232Control: 'Serial Control',
    vcbIRControl: 'IR Control',
    vcbSetting: '  CBX Setting',
    editVcb: 'Editing CBX',
    vcbName: 'CBX Name',
    iot: 'CBX Control',
    saveAsTemplate: 'Save as template',
    saveAsTemplatereplenish: 'Select multiple devices to use the template in Control Center',
    Upload: 'Upload',
    Select: 'Select',
    InputDeviceID: 'Input Device ID',
    editNameTips: '* The content on the left is displayed by default while the input box on the right is empty.',
    "_RS232A": 'Interface One',
    "_RS232B": 'Interface Two',
    institutionDirectory: 'Institution Directory',
    projectionScreenLinkageSetting: "Projection screen control setting",
    screenLiftingLinkageDisplaySwitch: "Projection screen and Display linkage control:",
    stopLinkage: "Disable (Control projection screen separately)",
    Enable: "Enable (Sync control of projection screen and display)",
    btnAddDevice: 'Add Device',
    btnImportDevice: 'Bulk Import Device',
    btnDel: 'Delete',
    btnEdit: 'Edit',
    tableIpAddress: "IP Address",
    "MACAddress": "MAC Address",
    "firmwareVersion": "Firmware Version",
    NA: "N/A",
    tableDeviceName: 'Device Name',
    tableStatus: 'Status',
    tableVideoSwitch: 'Video Switch',
    tableAudio: 'A/V Distribute',
    tablePowerControl: 'Power Control',
    tableRS232: 'Serial Control',
    tableIR: 'IR Control',
    tableRFIDCard: 'IC Card',
    tableControlPanel: 'Control Panel',
    tableOrganization: 'Groups',
    tableActions: 'Actions',
    dialogAddTitle: 'Add Device',
    dialogEditTitle: 'Editing Device',
    dialogBatchAddTitle: 'Bulk Add Device',
    dialogBatchEditTitle: 'Bulk Editing Device',
    btnCancel: 'Cancel',
    Devices: 'Devices:',
    ProjectorCode: 'Serial Code:',
    Group: 'Group:',
    btnBatchAdd: 'Bulk Add',
    delTitle: 'Delete?',
    delTitleContent: 'The selected components will be deleted from database. This process is irreversible. Are you sure you want to continue?',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    content: 'Search',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    tableDel: 'Delete',
    tableEdit: 'Edit',
    selectRoles: 'Select Roles',
    selectType: 'Please select a type',
    selectDevices: 'Please select a device',
    titleRealNameRq: 'This field must be filled',
    titleRealNameNub: 'less than 100 letters',
    titlPassWordNub: 'less than 15 letters',
    error1900: 'The parameter accessed is empty',
    error2000: 'Exceeded the maximum number of connectable devices',
    error2001: 'The imported device code is incorrect or has not been entered into the system yet.',
    error2002: 'Duplicate device name imported',
    error2003: 'The imported device ID has been used',
    error2004: 'Imported data error',
    error2005: 'The name of the brand or model duplicates existing data in the system; please rename the brand or model.',
    error2008: 'This device is already associated with another group',
    notDevicesName: 'Device name cannot be empty',
    notDevicesNO: 'Device ID cannot be empty',
    dialogDevicesName: 'Device name:',
    dialogDevicesID: 'Device ID:',
    dialogProjectorCode: 'Serial code:',
    dialogGroup: 'Group:',
    dialogSel: 'Please choose',
    errorOrgIdList: 'Group cannot be empty!',
    errorDevicesName: 'Device name cannot be empty!',
    errorDevicesNo: 'Device ID cannot be empty!',
    dialogTiltleDevices: 'Devices:',
    uploadSuccess: 'Upload succeed',
    addSuccess: 'Add succeed',
    ChooseGroups: 'Choose the Groups',
    ChooseIcon: 'Choose Icon',
    dialogDevicesTitle: 'The parameter settings are applied to the following devices',
    backDevice: 'Back',
    bootSetting: 'Startup Options',
    nmpOpenSetting: 'Power-on Settings',
    npsOpenSetting: 'Power-on Settings',
    nmpPowerSettings: 'Power Settings',
    npsPowerSettings: 'Power Settings',
    nmpInterfaceSettings: 'Interface Settings',
    npsInterfaceSettings: 'Interface Settings',
    nmpDefaultChannel: 'Default Channel Settings',
    nmpCloseSetting: 'Power-off Settings',
    npsCloseSetting: 'Power-off Settings',
    SwipeToStart: 'Enable lock (Tap card to unlock)',
    ControlPanelToStart: 'Disable lock (Unlimited operation)',
    Display: 'Display',
    External: 'External',
    startingUpMethod: 'Enable/disable panel lock:',
    startWith: 'Start with:',
    nmpstartWith: 'Sync Power-on:',
    nmpcloseWith: 'Sync Power-off:',
    RS232Tip: 'When the main power is turned off, a total of 5 Serial interfaces, including Serial and up to 4 CBXs,will receive the corresponding shutdown command code',


    startPowerTip: 'When powering on, all devices connected to CBX power ports will be turned on.',
    startAirTip: 'When powering on, all bound air conditioners will be turned on via infrared signals from the device/CBX.',
    startIrTip: 'When powering on, commands (e.g., screen retraction, projector off) will be sent via infrared signals from device/CBX.',
    startRSTip: 'When powering on, the power-on commands will be sent via the Serial ports of the device/CBX.',
    CloseDisplayTip: 'Display devices connected to the DISPLAY ports will automatically turn off when the NDP/NMP shuts down. This setting is managed by firmware and cannot be changed via software.',
    CloseExternalTip: 'Devices connected to the EXTERNAL ports will automatically turn off when the NDP/NMP shuts down. This setting is managed by firmware and cannot be changed via software.',
    ClosePowerTip: 'When shutting down, all devices connected to CBX power ports will be turned off.',
    CloseAirTip: 'When shutting down, all bound air conditioners will be turned on via infrared signals from the device/CBX..',
    CloseIrTip: 'When shutting down, commands (e.g., screen retraction, projector off) will be sent via infrared signals from device/CBX',
    CloseRSTip: 'When shutting down, the shutdown commands will be sent via the Serial ports of the device/CBX.',

    npsOpenRS232Tip: 'When the main power is turned on, the two serial ports of the NPS will receive the corresponding power-on command codes.',
    npsRS232Tip: 'When the main power is turned off, the two Serial interfaces of NPS will receive corresponding shutdown command codes.',
    useCardTip: 'After card unlock, Devices power will be automatically activated.',
    npsCardTip: 'After card unlock, Devices main power will be automatically activated.',
    PowerOutageHandling: 'Power Outage Handling',
    PowerOutageHandTip: "For continued access during unexpected power outages, choose 'Unlock on Power Outage.' Otherwise, select 'Lock on Power Outage' to restrict access",
    acSetting: 'A/C Setting',
    ChooseType: 'Device Type',
    ChooseBrand: 'Select a Brand',
    ChooseModel: 'Select a Model',
    btnConnectingTest: 'Connecting Test',
    LockSetting: 'Electric Lock Setting',
    ElectricLockType: 'Electric lock type:',
    PowerUNLOCK: 'Unlock on Power Outage',
    PowerLOCK: 'Lock on Power Outage',
    none: 'None',
    oddParity: 'Odd Parity',
    EvenParity: 'Even Parity',
    LastSetting: 'Last Setting',
    ElectricLockClosing: 'Electric lock closing:',
    manualSwitch: 'Manual switch',
    Auto: 'Auto (in ',
    projectorSetting: 'Device Selection and Binding',
    baudRate: 'Baud rate',
    Parity: 'Parity',
    /*ON:'ON',
     OFF:'OFF',*/
    ON: 'POWER ON',
    OFF: 'POWER OFF',
    Channel1: 'Channel 1',
    Channel2: 'Channel 2',
    PowerOffDelay: 'Power off delay',
    second: 's',
    DefaultChannel: 'Default Channel',
    HDMIA: 'HDMI out A:',
    HDMIB: 'HDMI out B:',
    HDMIC: 'HDMI out C:',
    btnSaveApply: 'Save and apply to...',
    btnSave: 'Save',
    btnCustomize: 'Custom',
    ACIsPowerTitle: 'Check if the A/C is powers on?',
    ACIsPowerContent: 'Please turn off the A/C before testing.If it does not turn on successfully, please make sure the A/C brand and model are correct.',
    btnNextModel: 'No, test the next model',
    btnYes: 'Yes',
    errorConnecting: 'Connecting test failed',
    hot: 'HOT',
    '_POWERA': 'Display Power',
    '_POWERB': 'External Power',
    '_MAGNETICLOCK': 'Electronic Lock',
    '_HDMI1': 'HDMI in 1',
    '_HDMI2': 'HDMI in 2',
    '_HDMI3': 'HDMI in 3',
    '_HDMIA': 'HDMI out A',
    '_HDMIB': 'HDMI out B',
    '_HDMIC': 'HDMI out C',
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    '_AIR': 'Air Conditioner',
    '_USB1': 'USB 1',
    '_USB2': 'USB 2',
    '_USB3': 'USB 3',
    '_USBA': 'USB A',
    '_USBB': 'USB B',
    IRControl: 'IR Control Setting',
    acControlTitle: 'Select a A/C Device:',
    acControlTitleNew: 'A/C Device',
    intelligentControlTitle: 'Select a Remote Control Device:',
    intelligentControlTitleNew: 'Remote Control Device',
    btnACControlCode: 'Identify New A/C control code',
    btnAddRemoteControl: 'New remote control code',
    ACControlCodeTitle: 'Identify A/C control Code',
    ACControlCodeseft1: "Identify Code",
    ACControlCodeseft2: "Add information",
    btnStartIdentify: 'Start',
    Identifysuccess: 'Identify successfully!',
    BeingIdentify: 'Analyzing...',
    acBrand: 'A/C Brand',
    acModel: 'A/C Model',
    IdentifyFailureTitle: "Failed to find the code",
    IdentifyFailureContent: 'The identification failed, this model is not supported currently. Please try the Remote Control',
    btnTryAgain: 'Try Again',
    btnJump: 'Go to remote control',
    ACrideo: 'A/C',
    ortherRideo: 'Other devices',
    btnBack: 'Back',
    btnSortOut: 'Go to edit',
    remoteControlSeft1: 'Select device type',
    remoteControlSeft2: 'Learn code',
    remoteControlSeft3: 'Add information',
    addRemoteControlError: 'Sorry, cannot learn more codes. Please edit the existing remote control codes first',
    btnPrevious: 'Previous',
    btnNextStep: 'Next',
    remoteControlErrorTitle: 'Failed to learn the code',
    remoteControlErrorContent1: '1. The infrared transmitter is not blocked',
    remoteControlErrorContent2: '2. No strong light interference around the receiver',
    remoteControlErrorContent3: '3. The infrared transmitter is installed correctly',
    remoteControlErrorContent4: '4. The remote control works well',
    deviceItem1: 'A/C',
    deviceItem2: 'Projector',
    deviceItem3: 'TV',
    deviceItem4: 'Fan',
    deviceItem5: 'Light',
    deviceItem6: 'Others',
    deviceItem7: 'Interactive Flat Panel',
    deviceItem8: 'Lecture Capture System',
    deviceItem9: 'PTZ Camera',
    RS232protocol: 'Serial protocol:',
    btnRemoteControl: 'Start to learn',
    BeingIdentify1: 'Analyzing...',
    Identifysuccess1: 'Success',
    controllerType1: 'A/C',
    controllerType2: 'Serial',
    controllerType3: 'TV',
    controllerType4: 'Fan',
    controllerType5: 'Light',
    controllerType9: 'Others',
    rqRemoteControlCode: 'Please enter the name of remote control code',
    rqBrand: 'Please enter the brand of A/C',
    rqModel: 'Please enter the model of A/C',
    error2016: 'The remote control name is duplicated, please enter another one',
    RS232Setting: 'Serial Code Setting',
    IR232Setting: 'IR Setting',
    SystemError: 'System Error. Please try again',
    conditionerCodeContent: "Don't find the air conditioner code, please try again",
    remoteControlCodeContent: "Don't find the remote control code, please try again",
    btnRetry: 'Retry',
    Bindusers: "Bind User",
    tablebinduser: 'Bind Users',
    Refresh: 'Refresh',
    Binduserlable: "Bind users who can control the device now?",
    SaveApplySuccessfully: 'Save and apply successfully',
    DeviceType: 'Type:',
    tableDeviceType: 'Type',
    empty: "It's empty.",
    sendCommand: 'Send later',
    enable: 'enable',
    disable: 'disable',
    SYNCremoteControl: 'SYNC with remote control',
    analysisfailed: 'The analysis failed, please try again!',
    // IRControl:'IR Control'
    CBX: {
      powerSupplyON: 'Power On',
      powerSupplyOFF: 'Power Off',
      powerVcrON: 'Start Recording',
      powerVcrOFF: 'Stop Recording',
      lockScreenON: 'Lock On',
      lockScreenOFF: 'Lock Off',
      childLockON: 'Child lock On',
      childLockOFF: 'Child lock Off',
      energySavingON: 'Energy saving On',
      energySaving: 'Energy saving',
      energySavingOFF: 'Energy saving Off',
      signalSourceSwitchingON: 'OPS',
      signalSourceSwitchingOFF: 'Android',
      volumeAdjustment: 'Speaker',
      brightAdjustment: 'Brightness',
      other: 'Other features...',
      volumeExample: 'Complete Serial control functionality required for full compatibility with the recording system.',
      functionCode: 'Function:',
      Name: 'Name:',
      controlCode: 'Control Code:',
      brand: 'Brand:',
      model: 'Model:',
      errorBrandName: 'Brand cannot be empty!',
      errorModelName: 'Model cannot be empty!',
    }

  },
  roleMge: {
    role1: 'General User',
    role101: 'Agent Admin',
    role102: 'Administrator',
    role4: 'Custom role',
    roleNew: 'New Role',
    btnAddRole: 'Add Role',
    RoleName: 'Role Name:',
    chooseUser: 'Choose User',
    titleLevel: 'Broadcasting Property Level:',
    titleSettings: 'Permission Settings:',
    btnSave: 'Save',
    btnDelete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    V3_0_OrganizationManage: 'Group Management',
    V3_0_UserManage: 'Users Management',
    V3_0_DeviceManage: 'Devices Management',
    V3_0_CloudSpaceManage: 'Cloud Space Management',
    V3_0_OrganizationManage_View: 'View',
    V3_0_OrganizationManage_Edit: 'Edit',
    V3_0_UserManage_View: 'View',
    V3_0_UserManage_Edit: 'Edit',
    V3_0_DeviceManage_AddDevice: 'Add Device',
    V3_0_DeviceManage_Operating: 'Operating',
    V3_0_DeviceManage_Delete: 'Delete',
    V3_0_DeviceManage_Edit: 'Edit',
    V3_0_CloudSpaceManage_PersonalManage: 'Personal cloud management',
    V3_0_CloudSpaceManage_PublicManage: 'Public cloud managemen',
    V3_0_CloudSpaceManage_SpaceManage: 'Space Allocation',
    V3_0_CloudSpaceManage_PersonalManage_Operating: 'Operating',
    V3_0_CloudSpaceManage_PersonalManage_View: 'View',
    V3_0_CloudSpaceManage_PublicManage_View: 'View',
    V3_0_CloudSpaceManage_PublicManage_Upload: 'Upload',
    V3_0_CloudSpaceManage_PublicManage_Download: 'Download',
    V3_0_CloudSpaceManage_PublicManage_DeleteFile: 'Delete File',
    V3_0_CloudSpaceManage_PublicManage_EditFolder: 'Edit Folder',
    delTitle: 'Delete?',
    delTitleContent: 'The selected contents will be deleted from database. This operation cannot be undone. Are you sure you want to continue?',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    btnAdd: 'Add Role',
    RoleName: 'Role Name:',
    ManageRange: 'Manage Range:',
    ChooseUser: 'Choose User:',
    PermissionSettings: 'Permission Settings:',
    BroadcastingPropertyLevel: 'Broadcasting Property Level',
    ChooseGroups: 'Choose the Groups',
    ChooseTheUser: 'Choose the User',
    deleleTitle: 'The new role has not been saved. If you leave, the role will be deleted. Are you sure to leave?',
    Error1601: 'Cannot use administrator',
    Error1602: 'Failed to get permission role',
    Error1603: 'Only administrators have access to such features',
    Error1604: 'Role name cannot be empty',
    Error1605: 'Group cannot be empty',
    Error1606: 'This role already exists',
    Error1607: 'System-defined role, modification is not allowed',
    Error1608: 'Setting role failed',
    Error1609: ' System common user role, modification is not allowed',
    Error1610: 'Please use the terminal administrator role to perform related operations',
    Error1611: 'Does not have related role permissions',
  },
  projectorDevicesMge: {
    tipOne: '1. Fill in the function name and control code. Control code examples use HEX format.',
    tipTwo: '2. This interface is only for power on/off serial command configuration. Please go to "Device Management / Devices / Operations / Power Settings" to enable the function.',
    tipFunctionOne: '1. Select common functions from the dropdown list. The corresponding icons will be displayed on the serial control interface of the smart panel.',
    tipFunctionTwo: '2. "POWER ON" and "POWER OFF" commands are used for device power on/off serial linkage. This page only configures control codes. Please go to "Device Management / Devices / Operations / Power Settings" to enable the linkage function.',
    ListRS232functions: 'Serial Control Function List',
    Customizefunctionlist: 'Customize the function list',
    btnAddProjectorCode: 'Add  Serial Code',
    btnDel: 'Delete',
    inputSeach: 'Search',
    btnEdit: 'Edit',
    cancel: 'Clean',
    confirm: 'Confirm',
    tableName: 'Code Name',
    tablersType: 'Device Type:',
    tablersTypeTable: 'Device Type',
    tableModel: 'Model',
    tableBrand: 'Brand',
    tableActions: 'Actions',
    dialogAddTitle: 'Add Serial Code',
    dialogEditTitle: 'Edit Serial Code',
    brand: 'Brand Name:',
    model: 'Model:',
    baudRate: 'Baud Rate:',
    parity: 'Parity:',
    powerOn: 'ON',
    powerOff: 'OFF',
    pgrInput1: 'Channel 1',
    pgbInput2: 'Channel 2',
    // video:'VIDEO:',
    // other:'OTHER:',
    // hdmi:'HDMI:',
    // standby:'STANDBY:',
    // powerSaving:'POWER SAVING:',
    // svideo:'SVIDEO:',
    delTitle: 'Delete?',
    delTitleContent: 'The selected contents will be deleted from database. This operation cannot be undone. Are you sure you want to continue?',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    content: 'Search',
    operate: 'Actions',
    tableDel: 'Delete',
    tableEdit: 'Edit',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    selectTitle: 'Please select a Serial!',
    selectCode: 'Select Serial',
    none: 'None',
    oddParity: 'Odd Parity',
    EvenParity: 'Even Parity',
  },

  authorityMge: {
    V3_0_OrganizationManage: 'Group Management',
    V3_0_UserManage: 'Users Management',
    V3_0_DeviceManage: 'Devices Management',
    V3_0_CloudSpaceManage: 'Cloud Space Management',
    V3_0_OrganizationManage_View: 'View',
    V3_0_OrganizationManage_Edit: 'Edit',
    V3_0_UserManage_View: 'View',
    V3_0_UserManage_Edit: 'Edit',
    V3_0_DeviceManage_AddDevice: 'Add Device',
    V3_0_DeviceManage_Operating: 'Operating',
    V3_0_DeviceManage_Delete: 'Delete',
    V3_0_DeviceManage_Edit: 'Edit',
    V3_0_DeviceManage_RepairLog: 'RepairLog',
    V3_0_CloudSpaceManage_PersonalManage: 'Personal cloud management',
    V3_0_CloudSpaceManage_PublicManage: 'Public cloud management',
    V3_0_CloudSpaceManage_SpaceManage: 'Cloud space Management',
    V3_0_CloudSpaceManage_PersonalManage_Operating: 'Operating',
    V3_0_CloudSpaceManage_PersonalManage_View: 'View',
    V3_0_CloudSpaceManage_PublicManage_View: 'View',
    V3_0_CloudSpaceManage_PublicManage_Upload: 'Upload',
    V3_0_CloudSpaceManage_PublicManage_Download: 'Download',
    V3_0_CloudSpaceManage_PublicManage_DeleteFile: 'Delete',
    V3_0_CloudSpaceManage_PublicManage_EditFolder: 'Edit',
    delTitle: 'Delete?',
    delTitleContent: 'The selected components will be deleted from database. This process is irreversible. Are you sure you want to continue?',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    content: 'Search',
    operate: 'Action',
    tableDel: 'Delete',
    tableEdit: 'Edit',
    addSuccess: 'Add successfully!',
    addError: 'Fail to add!',
    editSuccess: 'Edit successfully!',
    editError: 'Fail to edit!',
    delSuccess: 'Delete successfully!！',
    delError: 'Fail to delete!',
    selectTitle: 'Please select Serial!',
  },
  workstationMge: {
    priorChoice: 'Broadcast Preference:',
    SpeedPriority: 'Speed Priority',
    SyncPriority: 'Frame Sync Priority',
    SpeedPriorityTip: 'After AV broadcasting instructions are sent, Q-NEX terminals can carry out playing task in a shorter buffer time around 3-5 seconds. Speed priority is highly recommended when Media Server works in LAN.',
    SyncPriorityTip: 'After AV broadcasting instructions are sent, Q-NEX terminals can carry out playing task synchronously with a buffer time around 8-12 seconds. ',
    btnAddMedia: 'Add Media Server',
    btnBack: 'Back',
    tableMediaLibId: 'Media Server ID',
    tableMediaLibName: 'Media Server Name',
    tableState: 'Network Status',
    tableBindingUsers: 'Binding Users',
    tableLiveAddress: 'Streaming Address',
    tableAddress: 'Broadcast Address',
    tableOperate: 'Actions',
    tableDel: 'Delete',
    tableEdit: 'Edit',
    titleMediaStation: 'Broadcast Address',
    titleLiveStation: 'Streaming Address:',
    radioPublic: 'Public',
    radioPrivate: 'Private',
    btnSave: 'Save',
    titleUsers: 'Users',
    titleCanBe: 'Can Be Bound',
    titleHaveBeen: 'Have Been Binding',
    titleMore: 'Need to ADD More?',
    btnAdd: 'Add',
    content: 'Search',
    tableName: 'Name',
    tableUserName: 'UserName',
    operate: 'Actions',
    affiliatedOrganization: 'Groups',
    dialogTitle: 'Add New Media Server',
    dialogTitleEdit: 'Edit New Media Server',
    dialogItemName: 'Name:',
    dialogItemId: 'ID:',
    dialogItemIp: 'Broadcast Address:',
    titleSelectUsers: 'Select Users',
    selectUser: 'Please choose user',
    selectMedia: 'Please choose media',
    delTitle: 'Are you sure to delete?',
    delMediaLibTitle: 'Delete Confirmation?',
    delTitleContent: 'The selected contents will be deleted from database. This operation cannot be undone. Are you sure you want to continue?',
    delTitleMediaLibContent: 'The deleting action will cause the relevant data to be cleared and cannot be revoked.',
    delCancelButton: 'Cancel',
    delConfirmButton: 'Confirm',
    selectDevices: 'Please select devices',
    selectUser: 'Please selectusers',
    addUser: 'Add User',
    editUser: 'Edit User',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    error2500: 'Exceeded maximum number of devices that can be connected to the current workstation.',
    DeviceName: 'Device Name',
    AssociatedUserManagement: 'Associated Users Management',
    btnDel: 'Delete',
    errorMsgId: "Can't find this ID",
    LiveStreaming: 'Streaming Address:',
    NoFoundMediaId: 'Cannot get the ID of the media server',
    AlreadyConnectedOrg: 'The media server is already associated with another organization',
    AlreadyBoundMedia: 'This organization has already bound a media server, and cannot bind one more',
    DeleteSecondaryConfirmation: 'The data cannot be recovered after deleting the media server, please confirm again. '
  },
  cloudDiskMge: {
    totalStorage: 'TOTAL STORAGE',
    GetMore: 'Get More',
    StorageSpace: 'Storage Space',
    Adjustment: 'Adjustment',
    moreSpace: 'Get More Storage Space',
    PublicStorage: 'Public Storage',
    IndividualStorage: 'Personal Storage',
    PublicStorageUsed: 'Public Storage Used',
    PublicStorageLasted: 'Public Storage Remained',
    IndividualStorageUsed: 'Personal Storage Used',
    IndividualStorageLasted: 'Personal Storage Remained',
    storageSpace: 'Storage Space Adjustment',
    tableUserName: 'User Name',
    tableUsedSpace: 'Used Space',
    tableAvailableSpace: 'Available Space',
    tableActiveTime: 'Last Active Time',
    tableOperate: 'Actions',
    cleanup: 'Note to cleanup',
    IndividualStorageSpaceAdjustment: 'Personal Storage Space Adjustment',
    titleTotal: 'Total',
    PublicDisk: 'Public Cloud',
    IndividualDisk: 'Personal Cloud',
    PerUser: 'Per User',
    UsersInTotal: 'Total Users',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    addSuccess: 'Add Successfully!',
    addError: 'Fail to Add!',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    delSuccess: 'Delete Successfully!',
    delError: 'Fail to Delete!',
    error3000: 'The operation failed because the total size of storage has been exceeded.',
    error3003: 'Failed operation, please check if a Media Server has been set.',
    IndividualStorage: 'Personal Storage',
    NoteToCleanup: 'Note to cleanup',
    updatePersonalSuccess: 'Your cloud storage space will be full, please clean up in time',
    updatePersonalSuccess1: 'Modified and saved Successfully',
    storageUsage: 'Usage of Personal Storage',
    bindIndividualstorage: 'Users allowed to have personal cloud storage',
    UserIndividualstorage: 'Users already set up personal cloud storage',
    Notificationsuccessfully: 'Notification sent Successfully',
    Notificationfailed: 'Notification sent failed',
    tableName: 'Name',
    userID: 'User ID',
  },
  dashboard: {
    exportPdf: 'Export PDF',
    'or': '-',
    // 'startTime':'Start Time',
    // 'endTime':'End Time',
    'warrantyCompletionRate': 'Repair completion rate',
    'frequencyOfEachModule': 'The repair percentage of each functional module',
    'repairHandling': 'Processing status of repair',
    'sourceSwitchInput': 'Input switch',
    'micVol': 'Mic volume',
    'volumeSpeaker': 'Speaker volume',
    'airAonditioner': 'A/C',
    'Curtain': 'Projector screen',
    'remoteControlIntelligent': 'Remote control',
    'RS232Control': 'Serial control',
    'lockElectronic': 'Electronic locks',
    'Repairreportcompleted': 'Repaired',
    'Totalnumberofrepairsreported': 'Total repairs',
    'Warrantycompletionrate': 'Repair completion rate',
    'startDate': 'Start Date',
    'endDate': 'End Date',
    'year': 'year',
    'month': 'month',
    'day': 'day',
    dayTian: 'day',
    'placeholderDate': 'Select Date',
    'placeholderDateTime': 'Select Time',
    'devicesNub': 'Devices',
    'userNub': 'Users',
    'powerNub': 'Power(KW/H)',
    'storageUsed': 'Storage Used(%)',
    'userLoginDevice': 'User login active time period',
    'devicePowerConsumption': 'Daily electricity consumption of all devices',
    'externalDeviceUsageTime': 'External device usage',
    'equipmentRunningTime': 'Terminal device usage',
    'cloudStorageSpace': 'Storage Usage',
    'powerConsumptionPort': 'Power Consumption of Each Power Port',
    'mostPopularFile': 'Most Popular File',
    'commonFunctions': 'Commonly Functions',
    'commonlyUsed': 'Commonly Used Broadcast Method',
    'fileName': 'File Name',
    'usageCount': 'Usage Count',
    'electricityConsumption': 'Electricity Consumption',
    'publicStorageUsed': 'Public Storage Used',
    'publicStorageLasted': 'Public Storage Remained',
    'individualStorageUsed': ' Individual Storage Used',
    'individualStorageLasted': 'Individual Storage Remained',
    'total': 'Total',
    'notification': 'Notification',
    'audioBroadcast': 'Audio Broadcast',
    'videoBroadcast': 'Video Broadcast',
    'ac': 'A/C',
    'hDMISwitch': 'HDMI Switch',
    'powerControl': 'Power Control',
    'powercontrol': 'Power Control',
    'Lock': 'Lock',
    'volumeAdjust': 'Volume Adjust',
    'projectionScreen': 'Projection Screen',
    'today': 'Today',
    'yesterday': 'Yesterday',
    'thisWeek': 'This week',
    'lastWeek': 'Last week',
    'lastMonth': 'Last month',
    'thisMonth': 'This month',
    'times': 'Times',
    'usage': 'Usage Count',
    'eachrTitle': 'Minutes',
    total: 'Total',
    NMPSystemissue: 'NMP System issue',
    displayPower: 'NMP External device issue',
    externalPower: 'MBX System issue',
    screen: 'MBX External device issue',
    TotalRepairs: 'Total Repairs',
    Repaired: 'Repaired',
    Unrepaired: 'Unrepaired',
    day: 'DAY',
    Minutes: 'Minutes',
    powerConsumption: 'Minutes',
    Date: "Date",
    kw: 'KW',
    month1: 'MON',
    month2: 'TUE',
    month3: 'WED',
    month4: 'THU',
    month5: 'FRI',
    month6: 'SAT',
    month7: 'SUN',
    enmonth1: 'Jan',
    enmonth2: 'Feb',
    enmonth3: 'Mar',
    enmonth4: 'Apr',
    enmonth5: 'May',
    enmonth6: 'Jun',
    enmonth7: 'Jul',
    enmonth8: 'Aug',
    enmonth9: 'Sep',
    enmonth10: 'Oct',
    enmonth11: 'Nov',
    enmonth12: 'Dec',
    noData: 'No Data'
  },
  input: {
    fivedigits: 'Please enter a positive integer within 5 digits',
    titlUserNameField: 'This UserName must be filled.',
    thisField: 'This field must be filled.',
    ChooseGroup: 'ChooseGroup',
    placeholder: 'Select',
    placeholder_type: 'Please select device control types',
    titlRealNameField: 'Password must be filled.',
    thisPasswordField: 'Password must be filled.',
    titlPassWordNub: 'less than 15 letters',
    Post: 'Numbers only',
    passwordNoChinese: 'This input box cannot be filled with Chinese characters'
  },
  transfer: {
    all: 'All',
    Choose: 'Choose',
    Selected: 'Selected',
    Subordinate: 'Subordinate'
  },
  setting: {
    limitPngGif: 'Only PNG / GIF formats are supported',
    limit3M: 'Image size must not exceed 3MB',
    setting_door_Wallpaper_text: 'Recommended image size: 1280x800, PNG or GIF format',

    reduction: 'Restore',
    limitJpg: 'The uploaded profile picture can only be in PNG format!',
    limit2M: 'The size of the uploaded profile picture cannot exceed 2MB!',
    choseFile: 'Select the file',
    textOne: '1.Recommended LOGO image: size 117*40, in PNG format ',
    textTwo: '2.After uploading is done, please turn to Touch Panel, and make sure that Touch Panel is connected to Internet, then click on the original logo to refresh.',
    customizeLogo: 'Touch Panel Logo Setting',
    addSuccess: 'Setting succeeded!',
    settingIp: 'File Storage IP Setting',
    ServerIP: 'Server IP Address:',
    ServerPort: 'Server Port:',
    btnSave: 'Save',
    TimeZoneSetting: 'Time Zone Setting',
    CurrentTime: 'Current Time:',
    CurrentTimeZone: 'Current Time Zone:',
    httpsSetting: 'File Storage:',
    utcName: 'Greenwich Mean Time UTC/GMT',
    utc0: 'Greenwich Mean Time, United Kingdom, Lisbon, Torshavn, London, Dublin, Edinburgh',
    utc0_5: '',
    utc1: 'Central Europe, West Africa, West Central Africa, Germany, Ireland, France, Amsterdam, Italy, Berlin, Rome, Spain, Prague, Belgrade, Brussels, Paris, Madrid, Tunisia, Gabon, Morocco',
    utc1_5: '',
    utc2: 'Eastern Europe, Central Africa, Turkey, Israel, South Africa, Istanbul, Cairo, Athens, Damascus',
    utc2_5: '',
    utc3: 'East Africa, Russia, Baghdad, Kuwait, Moscow, St. Petersburg',
    utc3_5: 'Iran',
    utc4: 'Abu Dhabi, Tbilisi, Dubai, Mauritius, Port Louis',
    utc4_5: 'Afghanistan',
    utc5: 'Pakistan, Turkmenistan, Maldives, Uzbekistan, Armenia, Tajikistan India, Mumbai, New Delhi, Bangalore, Kolkata',
    utc5_5: 'India, Sri Lanka',
    utc6: 'Novosibirsk, Kyrgyzstan, Bangladesh, Bhutan',
    utc6_5: 'Cocos Islands Australia, Vietnam',
    utc7: 'Thailand, Bangkok, Hanoi, Jakarta',
    utc7_5: '',
    utc8: 'China, Malaysia, Philippines, Singapore, Taiwan China, Macau China, Hong Kong China',
    utc8_5: '',
    utc9: 'Japan, South Korea, Tokyo, Seoul, Sapporo, Osaka, East Timor',
    utc9_5: 'Australian Central Standard Time',
    utc10: 'Australia, Vladivostok, Guam, Canberra, Melbourne, Sydney, Papua New Guinea',
    utc10_5: 'Lord Howe Island of New South Wales, Australia',
    utc11: 'Solomon Islands, Sakhalin Island',
    utc11_5: 'Norfolk Island, Australia',
    utc12: 'New Zealand, Auckland, Wellington, Fiji, New Zealand, Nauru',
    utc12_5: '',
    utc13: 'Cape Verde, Azores',
    utc13_5: '',
    utc14: 'South Georgia, Fernando de Noronha',
    utc14_5: '',
    utc15: 'Brazil, Santiago, El Salvador, Brasilia, Uruguay, Argentina, Suriname',
    utc15_5: 'Newfoundland Standard Time',
    utc16: 'Venezuela, Bolivia, Paraguay, Chile',
    utc16_5: 'Venezuela',
    utc17: 'Eastern Time (US and Canada), Colombia, Toronto, Ecuador, Peru, Cuba, New York, Hamilton, San Diego',
    utc17_5: '',
    utc18: 'U.S. and Canadian Central Time, Mexico City, Monterrey, Chicago, Houston, New Orleans, Memphis',
    utc18_5: '',
    utc19: 'Mountain Time, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton',
    utc19_5: '',
    utc20: 'Pacific Time, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas',
    utc20_5: '',
    utc21: 'Alaska',
    utc21_5: 'French Polynesia,Marquesas Islands',
    utc22: 'Hawaii',
    utc22_5: '',
    utc23: 'Samoa, Niue',
    utc23_5: '',
    utc24: '',
  },
  repairLog: {
    // tabAll:'ALL',
    // tabDelivered:'Delivered',
    // tabInProcess:'In Process',
    // tabCompleted:'Completed',
    DeviceName: 'Device Name:',
    Time: 'Time:',
    startDate: 'Start Date',
    endedDate: 'Ended Date',
    or: '-',
    Problem: 'Problem:',
    btnSearch: 'Search',
    tableNO: 'No',
    tableDeviceName: 'DeviceName',
    tableGroup: 'Group',
    tableStatus: 'Status',
    tableDeliveredTime: 'Delivered Time',
    tableSubmitter: 'Submitter',
    tableUpdatingTime: 'Updating Time',
    tableProblem: 'Problem',
    tableAdmin: 'IT-Admin',
    tableAdminReply: 'Admin Reply',
    tableAttachment: 'Attachment',
    state0: 'Delivered',
    state1: 'In Process',
    state2: 'Completed',
    Problem100: 'ALL',
    Problem0: 'System Problem',
    Problem1: 'External Device Problem',
    ProblemType: '',
    ProblemType0: 'Power Control',
    ProblemType1: 'HDMI Switch',
    ProblemType2: 'Mic',
    ProblemType3: 'Speaker',
    ProblemType4: 'A/C',
    ProblemType5: 'Projector Screen',
    ProblemType6: 'Electric Lock',
    ProblemType7: 'A/V Broadcasting',
    ProblemType8: 'IR Control',
    ProblemType9: 'Serial Control',
    dialogDeviceName: 'Device Name',
    dialogDeviceID: 'Device ID',
    dialogGroup: 'Group',
    dialogDeliveredTime: 'Delivered Time',
    dialogSubmitter: 'Submitter',
    dialogStatus: 'Choose status',
    dialogProblem: 'Problem',
    dialogNotes: 'Notes',
    dialogRepairation: 'Repairation',
    dialogInProcess: 'In Process',
    dialogCompleted: 'Completed',
    editSuccess: 'Edit Successfully!',
    editError: 'Fail to Edit!',
    problemRequired: 'Please select a problem type',
    detailRequired: 'Please describe the problem in detail',
    statusRequired: 'Please choose the log status',
    btnCancel: 'Cancel',
    DeliveredTime: 'Delivered Time',
    UpdatingTime: 'Updating Time',
    Submitter: 'Submitter',
    ITAdmin: 'IT-Admin',
    AdminReply: 'Admin Reply',
    Note: 'Note',
    Detail: 'Detail',
    controlPanel: 'Control Panel',
    DeviceType: 'Type',
    dialogDeliveredTime: 'Delivered Time',
    Submitter: 'Submitter',
  },
  remoteControl: {
    QuickActionName: 'Name',
    DeviceType: 'Type',
    Description: 'Description',
    tableDescription: 'Description',
    editRemoteControl: 'Edit Remote Control Code',
    QuickActionNameInput: 'Name',
    DescriptionInput: 'Description',
    save: 'Save',
    Brand: 'Brand',
    Model: 'Model',
    EditACControlCode: 'Edit A/C Control Code',
    acBrand: 'A/C Brand',
    acModel: 'A/C  Model'
  },
  card: {
    btnAddCard: 'Add Card',
    btnBatchAddCard: 'Batch Add Cards',
    tableCard: 'Card Number',
    tableState: 'Status',
    tableUser: 'Bind User',
    tableID: 'User Name',
    tableType: 'Card Type',
    tableFfective: 'Expiry Date',
    dialogCard: 'Card Number:',
    dialogState: 'Status:',
    dialogUser: 'Bind User:',
    dialogID: 'User Name:',
    dialogType: 'Card Type:',
    dialogFfective: 'Expiry Date:',
    dialogRemarks: 'Remarks:',
    dialogAddTitle: 'Add Card',
    dialogEidtTitle: 'Edit Card',
    code2201: 'The expiry period format of the card is incorrectly',
    code2202: 'This card has been bound',
    code2203: 'This user has been bound',
    code2204: 'This card is not bound',
    mastCard: 'Master Card',
    regularCard: 'General Card',
    permanent: 'Permanent',
    coxPermanent: 'Permanent',
    coxTime: 'A certain period of time',
    tableDeviceName: 'Device Name',
    tableDeviceID: 'Device ID',
    tableOperating: 'Operation',
    tableOperatingTime: 'Operating Time',
    tableCardID: 'Card Number',
    tableCardType: 'Card Type',
    tabluserName: 'Username',
    tabluserId: 'User ID',
    unlockPanel: 'Unlock Panel',
    unlock: 'Unlock Door',
    conAll: 'All',
    btnEnable: 'Enable',
    btnDisable: 'Disable',
    enableSuccess: 'Enable successfully',
    stopSuccess: 'Disable successfully',
    enableError: 'Failed to enable',
    stopError: 'Failed to disable',
    batchCard: 'Batch Card Number:',
    titlCardField: 'Card number cannot be empty',
    titlCardFieldFormat: 'Only letter and number',
    dialogBachAddTitle: 'Batch Add Cards',
    pleaseTryAgain1: 'Wrong card number (NO. :',
    pleaseTryAgain2: '), please try again',
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js